<template>
    <div class="main">
        <headerBar current="/" home="true"></headerBar>
        <div class=" line">
        </div>
        <div class="banner"></div>
        <div class="ad">
            <img src="../assets/mobile/ad.png" />
        </div>
        <div class="tab">
            <ol>
                <li :class="current == 1 ? 'on' : ''" @click="tabBtn(1)"> 联运通</li>
                <!-- <li :class="current == 2 ? 'on' : ''">联运小哥</li>
                <li :class="current == 3 ? 'on' : ''" @click="tabBtn(3)"> MTS-API</li> -->
            </ol>
            <ul>
                <li v-if="current == 1 ? 'on' : ''">
                    <h3>
                        <img src="../assets/icon-admin.png" />
                        <i>涉铁物流企业的数字化运营管理平台</i>
                    </h3>
                    <p>
                        以铁路运输业务数字化连接能力为基础，为各类涉铁物流企业客户提供电子化的履约追踪、电子运单、企业间结算、自备箱(车)等运输资产的运用位置和运用状态管理的一站式数字化运营解决方案。
                    </p>
                </li>
                <li v-if="current == 2 ? 'on' : ''">
                    <h3>
                        <img src="../assets/icon-fun.png" />
                        <i>联运资源的集散和集成服务</i>
                    </h3>
                    <p>以众包模式和系统对接模式为基础的联运资源需求、供给社区。包括：人工询价、场站地接、物流业务撮合、铁运信息API集成对接、工具租用、取送代办等跑腿服务，专属资源，包括数据资源的发布等资源集散、集成服务。</p>
                </li>
                <li v-if="current == 3 ? 'on' : ''">
                    <h3>
                        <img src="../assets/icon-service.png" />
                        <i>为客户自主研发的业务管理系统提供与铁路运输方式相关数据采集和加工处理服务对接功能</i>
                    </h3>
                    <p>·&nbsp&nbsp&nbsp&nbsp铁路运踪服务综合API&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp·&nbsp&nbsp&nbsp&nbsp铁路发运服务综合API&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp·&nbsp&nbsp&nbsp&nbsp铁路结算综合服务API</p>
                </li>
            </ul>
        </div>
        <div class="service">
            <div class="title">为您提供的服务</div>
            <div class="content">
                <div class="lab">
                    <p :class="active == 1 ? 'on' : ''" @click="switchBtn(1)">多式联运项目开发及运营</p>
                    <p :class="active == 2 ? 'on' : ''" @click="switchBtn(2)">自备车（箱）资产运营</p>
                    <p :class="active == 3 ? 'on' : ''" @click="switchBtn(3)">业财务结算统计自动化</p>
                    <p :class="active == 4 ? 'on' : ''" @click="switchBtn(4)">场站及园区运营智能化</p>
                    <p :class="active == 5 ? 'on' : ''" @click="switchBtn(5)">平台应用开放API服务</p>
                </div>
                <div class="info" v-show="active == 1">
                    <div>
                        <h3>多式联运项目开发及运营</h3>
                        <h4>国内、国际多式联运的项目组织集成化、可视化服务</h4>
                        <router-link tag="ul" to="/solution?index=1">
                            <li style="width: 60%">物流项目运踪轨迹查询</li>
                            <li style="width: 40%">场站运力资源线上查询</li>
                            <li style="width: 60%">国内、国际多式联运集成化管理</li>
                            <li style="width: 40%">运营统计台账自动化</li>
                            <li style="width: 60%">多联产品线路开发</li>
                            <li style="width: 40%">产品辅助开发</li>
                        </router-link>
                    </div>
                    <img src="../assets/service1.png" />
                </div>
                <div class="info" v-show="active == 2">
                    <div>
                        <h3>自备车（箱）资产运营</h3>
                        <h4>
                            以铁路自备车和自备箱资产动态运营为主的数字化服务
                        </h4>
                        <router-link tag="ul" to="/solution?index=2">
                            <li>自备车（箱）信息数字化管理</li>
                            <li>自备车（箱）动态位置轨迹管理</li>
                            <li>自备车（箱）运用状态管理</li>
                            <li>承运运单信息管理</li>
                            <li>自备车定检信息查询提醒</li>
                            <li>资产运用周转率统计</li>
                        </router-link>
                    </div>
                    <img src="../assets/service2.png" />
                </div>
                <div class="info" v-show="active == 3">
                    <div>
                        <h3>业财务结算统计自动化</h3>
                        <h4>
                            项目客户及供应商结算数据的自动化提取与统计、呈现服务
                        </h4>
                        <router-link tag="ul" to="/solution?index=3">
                            <li>运营统计台账</li>
                            <li>上下游收支对账及明细</li>
                            <li>运费资金动态余额管理</li>
                            <li>业财核销线上可视化操作</li>
                        </router-link>
                    </div>
                    <img src="../assets/service3.png" />
                </div>
                <div class="info" v-show="active == 4">
                    <div>
                        <h3>场站及园区运营智能化</h3>
                        <h4>
                            货运代理、场站服务、资产租赁等企业与上下游企业协同线上化
                        </h4>
                        <router-link tag="ul" to="/solution?index=4">
                            <li>目履约统计与反馈</li>
                            <li>上下游运营数据与收支统计</li>
                            <li>场站管家运营管理</li>
                            <li>业务对接、客户服务（远程监装）</li>
                            <li>车（箱）资产周转量统计</li>
                            <li>资源需求的发布与受理</li>
                        </router-link>
                    </div>
                    <img src="../assets/service4.png" />
                </div>
                <div class="info" v-show="active == 5">
                    <div>
                        <h3>平台应用开放API服务</h3>
                        <h4>
                            为环铁路多式联运企业自主研发的物流及供应链管理系统，提供与铁路运输方式相关的数据采集、分析处理的技术对接、技术咨询和运维支持。
                        </h4>
                        <router-link tag="ul" to="/solution?index=5">
                            <li style="width: 33.33%">多式联运全程运踪</li>
                            <li style="width: 33.33%">项目运输组织</li>
                            <li style="width: 33.33%">铁路运单及上下游结算</li>
                            <li style="width: 33.33%">海关单一窗口</li>
                            <li style="width: 33.33%">海运订舱</li>
                            <li style="width: 33.33%">汽运派接单</li>
                            <li style="width: 33.33%">公铁海全程运踪</li>
                        </router-link>
                    </div>
                    <img src="../assets/service5.png" />
                </div>
            </div>
            <div class="swiper">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <h3>多式联运项目开发及运营</h3>
                            <p>国内、国际多式联运的项目组织集成化、可视化服务</p>
                            <img src="../assets/service1.png" />
                            <router-link tag="a" to="/solution?index=1">了解更多</router-link>
                        </div>
                        <div class="swiper-slide">
                            <h3>自备车（箱）资产运营</h3>
                            <p>以铁路自备车和自备箱资产动态运营为主的数字化服务</p>
                            <img src="../assets/service2.png" />
                            <router-link tag="a" to="/solution?index=2">了解更多</router-link>
                        </div>
                        <div class="swiper-slide">
                            <h3>业财务结算统计自动化</h3>
                            <p>项目客户及供应商结算数据的自动化提取与统计、呈现服务</p>
                            <img src="../assets/service3.png" />
                            <router-link tag="a" to="/solution?index=3">了解更多</router-link>
                        </div>
                        <div class="swiper-slide">
                            <h3>场站及园区运营智能化</h3>
                            <p>货运代理、场站服务、资产租赁等企业与上下游企业协同线上化</p>
                            <img src="../assets/service4.png" />
                            <router-link tag="a" to="/solution?index=4">了解更多</router-link>
                        </div>
                        <div class="swiper-slide">
                            <h3>平台应用开放API服务</h3>
                            <p>为环铁路多式联运企业自主研发的物流及供应链管理系统，提供与铁路运输方式相关的数据采集、分析处理的技术对接、技术咨询和运维支持。</p>
                            <img src="../assets/service5.png" />
                            <router-link tag="a" to="/solution?index=5">了解更多</router-link>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination" slot="pagination"></div>
            </div>
        </div>
        <contact></contact>
        <footerBar></footerBar>
    </div>
</template>

<script>
import headerBar from "../components/headerBar"
import contact from "../components/contact"
import footerBar from "../components/footerBar"
import Swiper from "swiper"
import "swiper/dist/css/swiper.css"
export default {
    name: "index",
    components: { headerBar, contact, footerBar, },
    data() {
        return {
            current: 1,
            active: 1,
        }
    },
    mounted() {
        new Swiper(".swiper-container", {
            slidesPerView: 1.5,
            spaceBetween: 10,
            speed: 500,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    },
    methods: {
        tabBtn(index) {
            this.current = index
        },
        switchBtn(index) {
            this.active = index
        },
    },
};
</script>

<style scoped>
@media screen and (min-width: 1025px) {
    .banner {
        height: 100vh;
        background: url("../assets/pc/banner.png") no-repeat center;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.7rem;
    }

    .ad {
        display: none;
    }

    .tab {
        width: 13rem;
        height: 3.6rem;
        margin: 1.6rem auto 0;
    }

    .tab ol {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tab ol li {
        padding: 0 0.4rem;
        font-size: 0.48rem;
        color: #b1bbc5;
        font-weight: bold;
        cursor: pointer;
    }

    .tab ol li.on {
        color: #091c2e;
    }

    .tab ul {
        margin-top: 0.6rem;
    }

    .tab ul li h3 {
        display: flex;
        align-items: center;
    }

    .tab ul li h3 img {
        width: 0.24rem;
    }

    .tab ul li h3 i {
        font-size: 0.22rem;
        margin-left: 0.2rem;
        color: #0b1d30;
        font-weight: bold;
    }

    .tab ul li p {
        font-size: 0.18rem;
        color: #656d75;
        line-height: 0.4rem;
        margin-top: 0.3rem;
    }

    .service {
        width: 13rem;
        margin: 0 auto;
    }

    .service .title {
        text-align: center;
        font-size: 0.48rem;
        color: #091c2e;
        font-weight: bold;
    }

    .service .swiper {
        display: none;
    }

    .service .content {
        margin-top: 0.8rem;
        display: flex;
        align-items: center;
    }

    .service .content .lab {
        width: 3rem;
    }

    .service .content .lab p {
        font-size: 0.18rem;
        color: #0b1d30;
        line-height: 0.6rem;
        cursor: pointer;
    }

    .service .content .lab p.on {
        color: #1070ff;
        font-weight: bold;
    }

    .service .content .info {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f5f7f9;
        padding-right: 0.2rem;
        height: 3rem;
    }

    .service .content .info div {
        padding-left: 0.4rem;
        flex: 1;
    }

    .service .content .info div h3 {
        font-size: 0.22rem;
        color: #091c2e;
        font-weight: bold;
    }

    .service .content .info div h4 {
        font-size: 0.18rem;
        color: #656d75;
        margin-top: 0.1rem;
        line-height: 0.32rem;
    }

    .service .content .info div ul {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 0.2rem;
    }

    .service .content .info div ul li {
        width: 50%;
        font-size: 0.15rem;
        color: #091c2e;
        line-height: 0.42rem;
        cursor: pointer;
        white-space: nowrap;
    }

    .service .content .info img {
        width: 3.6rem;
    }
}

@media screen and (max-width: 1024px) {
    .banner {
        height: 6.4rem;
        background: url("../assets/mobile/banner.png") no-repeat center;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;
    }

    .ad img {
        width: 100%;
    }

    .tab {
        padding: 0 0.2rem;
        background: url("../assets/mobile/circular-bg.png") no-repeat left 0.4rem;
        background-size: 2.42rem;
    }

    .tab ol {
        height: 1.2rem;
        padding-top: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tab ol li {
        font-size: 0.36rem;
        color: #3c3737;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.6;
        background: url("../assets/mobile/icon-tab1.png") no-repeat left center;
        background-size: 0.4rem;
        padding-left: 0.54rem;
    }

    .tab ol li+li {
        background: url("../assets/mobile/icon-tab2.png") no-repeat left center;
        background-size: 0.4rem;
        margin-left: 0.9rem;
    }

    .tab ol li.on {
        opacity: 1;
    }

    .tab ul li {
        padding: 0.4rem 0.2rem;
        border-radius: 0.24rem;
        box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.1);
    }

    .tab ul li h3 {
        display: flex;
        align-items: center;
    }

    .tab ul li h3 img {
        width: 0.32rem;
    }

    .tab ul li h3 i {
        margin-left: 0.2rem;
        font-size: 0.3rem;
        color: #294147;
        font-weight: bold;
        font-family: SongTi;
    }

    .tab ul li p {
        margin-top: 0.2rem;
        font-size: 0.26rem;
        color: #595959;
        text-indent: 2em;
        letter-spacing: 2.4px;
        line-height: 0.52rem;
    }

    .service {
        margin-top: 1rem;
        background: url("../assets/mobile/service-bg.png") no-repeat right bottom;
        background-size: 2.86rem;
        padding-bottom: 0.5rem;
    }

    .service .title {
        text-align: center;
        font-size: 0.36rem;
        color: #3c3737;
        font-weight: bold;
    }

    .service .content {
        display: none;
    }

    .service .swiper {
        margin-top: 0.5rem;
        padding: 0 0.2rem;
    }

    .service .swiper .swiper-slide {
        border: 2px solid rgb(234, 235, 255);
        border-radius: 0.2rem;
        height: 6rem;
        padding: 0.2rem;
        background: rgba(255, 255, 255, 0.4);
    }

    .service .swiper .swiper-slide h3 {
        font-size: 0.28rem;
        color: #060606;
        font-weight: bold;
    }

    .service .swiper .swiper-slide p {
        font-size: 0.26rem;
        color: #595959;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
    }

    .service .swiper .swiper-slide img {
        width: 100%;
        margin-top: 0.5rem;
    }

    .service .swiper .swiper-slide a {
        width: 1.4rem;
        line-height: 0.44rem;
        border-radius: 0.22rem;
        color: #fff;
        text-align: center;
        background: #0f70ff;
        display: block;
        margin-left: auto;
        font-size: 0.24rem;
        margin-top: 0.4rem;
    }

    .service .swiper .swiper-pagination {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.5rem;
    }

    .service .swiper .swiper-pagination>>>span {
        width: 0.14rem;
        height: 0.14rem;
        margin: 0 0.14rem;
    }

    .service .swiper .swiper-pagination>>>span.swiper-pagination-bullet-active {
        background: #000;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue